import React from "react";
import Orderpage from "./Order-page";
import { useLocation } from "react-router-dom";
const Personalinformation = () => {
    const location = useLocation()
    const stateData = location?.state
    console.log('Ordelocass', location);

    return (
        <div>
            <Orderpage stateData={stateData} />
        </div>
    );
}
export default Personalinformation;